import React from "react";
import PropTypes from "prop-types";
import { Router, Route, IndexRoute } from "react-router";
import { Provider } from "react-redux";
import queryString from "query-string";

import * as actions from "../actions";
import { getStore } from "../store";
import { filtersEmpty } from "../utils/objects";
import { getEnvSetting } from "../utils/env";
import { getUser } from "../selectors";

import Imprint from "./Imprint";
import Privacy from "./Privacy";
import Help from "./Help";
import Sponsors from "./Sponsors";
import About from "./About";
import UserRegistered from "./UserRegistered";
import AdminContainer from "../containers/AdminContainer";
import EmailAddressContainer from "../containers/EmailAddressContainer";
import AppContainer from "../containers/AppContainer";
import LoginContainer from "../containers/LoginContainer";
import LogoutContainer from "../containers/LogoutContainer";
import ResetPasswordContainer from "../containers/ResetPasswordContainer";
import UserEditFormContainer from "../containers/UserEditFormContainer";
import MainWrapperContainer from "../containers/MainWrapperContainer";
import EditInstitutionContainer from "../containers/EditInstitutionContainer";
import NewInstitutionContainer from "../containers/NewInstitutionContainer";
import ViewInstitutionContainer from "../containers/ViewInstitutionContainer";
import ValidateRegistrationContainer from "../containers/ValidateRegistrationContainer";
import { queryStringToFilters } from "../utils/filters";

const onChangeRoute = () => {
  getStore().dispatch(actions.closeNav());
};

const onEnterEdit = () => {
  getStore().dispatch(actions.clearEditInstitution());
};

const onEnterAdmin = () => {
  const is_admin = (getUser(getStore().getState()) || {}).is_admin;
  if (!is_admin) {
    // TODO redirect
    throw new Error("Access denied");
  }
  getStore().dispatch(actions.fetchUsers());
};

const onEnterUser = () => {
  getStore().dispatch(actions.clearEditUser());
};
const onEnterApp = () => {
  getStore().dispatch(actions.loadDistricts());
  getStore().dispatch(actions.loadCategories());
};

const onEnterMap = nextState => {
  let query_state = queryStringToFilters(nextState.location.search);
  if (filtersEmpty(query_state)) {
    query_state = {
      ...query_state,
      ...JSON.parse(getEnvSetting("REACT_APP_DEFAULT_FILTERS"))
    };
  }
  getStore().dispatch(actions.setFilters(query_state));
  getStore().dispatch(actions.setActiveInstitution(query_state.active));
};

const Root = props => {
  return (
    <Provider store={props.store}>
      <Router history={props.history}>
        <Route
          path="/"
          component={AppContainer}
          onEnter={onEnterApp}
          onChange={onChangeRoute}
        >
          <IndexRoute onEnter={onEnterMap} />
          <Route
            path="/map"
            onEnter={onEnterMap}
            component={MainWrapperContainer}
          />
          <Route path="/new" component={NewInstitutionContainer} />
          <Route
            path="/edit/(:key)"
            onEnter={onEnterEdit}
            component={EditInstitutionContainer}
          />
          <Route path="/view/(:key)" component={ViewInstitutionContainer} />
          <Route path="/imprint" component={Imprint} />
          <Route path="/privacy" component={Privacy} />
          <Route
            path="/user"
            component={UserEditFormContainer}
            onEnter={onEnterUser}
          />
          <Route
            path="/admin"
            component={AdminContainer}
            onEnter={onEnterAdmin}
          />
          <Route
            path="/confirm/:hash"
            component={ValidateRegistrationContainer}
          />
          <Route path="/registered" component={UserRegistered} />
          <Route path="/new-password" component={EmailAddressContainer} />
          <Route
            path="/reset-password/:token"
            component={ResetPasswordContainer}
          />
          <Route path="/login" component={LoginContainer} />
          <Route path="/logout" component={LogoutContainer} />
          <Route path="/help" component={Help} />
          <Route path="/sponsors" component={Sponsors} />
          <Route path="/about" component={About} />
        </Route>
      </Router>
    </Provider>
  );
};

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default Root;



/** WEBPACK FOOTER **
 ** ./src/components/Root.jsx
 **/